import { fileDownloadHandler } from "../commons/file-download-handler";
import { addContextLog } from "../../infrastructure/log";
import { downloadEmployeesAdjustments } from "../../infrastructure/repository/employees-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { translate } from "../../infrastructure/translate/localization";

export async function downloadEmployeeAdjustment(employee) {
  try {
    const { id: employeeId, companyId, legalId } = employee;
    const adjustmentsFileData = await downloadEmployeesAdjustments({
      employeeId,
      companyId,
    });
    const title = `adjustments-${legalId}`;

    addContextLog("info", "downloadEmployeeAdjustment", "download-file", {
      employeeId,
      companyId,
      adjustmentsFileData,
    });

    await fileDownloadHandler(title, adjustmentsFileData);
  } catch (e) {
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
